export default "./icons/sun.png";